import React from 'react'

const SpinnerController = () => {
  return (
    <img alt="logo"
    // style={{
    //     animation: 'spin 5s linear infinite',
    //     transform: 'rotate(0deg)'
    //   }} 
    // className="w-8 h-8"
    // style={{
    //   animation: 'blink 1s linear infinite',
    //   transform: 'scale(1.2)',
    //   transition: 'all 0.2s ease-in-out'
    // }}
    // className="animate-pulse inline-block w-10 h-10 rounded-full border-4 border-white shadow-md"
    className="animate-bounce w-8 h-8 rounded-full"
    src="assets/raptors.png"/>
  )
}

export default SpinnerController